export const isRN = () => Boolean(window.APP)
export const rnAble = (ability) => window.APP?.availabilities?.includes(ability) === true
export const rnSend = (action, payload, callback, fallBack = () => { }) => rnAble(action) ? window.APP.callNative(action, payload, callback) : (fallBack())
export const rnNavigate = (navigate, url) => {
  if (rnAble('navigationGoTo')) {
    rnSend('navigationGoTo', url)
  } else {
    navigate(url)
  }
}